export default function isSmallCard(element) {
  return element?.clientWidth <= 180;
}
